module.exports = __webpack_public_path__ + "static/media/group-cover-1.934b360a.jpg";